import React, { useState,useRef ,useEffect} from 'react';
import {useLocation,useParams} from 'react-router-dom';
import ElectricityComponent from '../components/Electricity';
import GasComponent from '../components/Gas';
import { DownOutlined } from '@ant-design/icons';
import {Col,Button,Dropdown,Form,Input,InputNumber,Row,Select,DatePicker,Space, notification, Flex, message} from 'antd';
import { surveyLeadSave, masterSource,clickId} from '../service/UserDetails';
import {loginUserId} from "../service/UserDetails";
import Item from 'antd/es/list/Item';
import moment  from 'moment';
import axios from "axios";
import { Divider } from 'antd';
import { Checkbox } from 'antd';
import { Modal } from "antd";
import FormItem from 'antd/es/form/FormItem';
import './quality.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


const RegistrationFormQuality = (props) => {

  const { id } = useParams();

  const [errors, setErrors] = useState([]);
  const [findUserOK, setFindUserOK] = useState(true);
  const [supplyNumber, setSupplyNumber] = useState('');
  const location = useLocation();
  const {state={}} = location || {};
  const {token="", user={},findUser={}, isEdit} = state || {};  
  const ref1 = useRef(); 
  const ref2 =  useRef();
  const [form] = Form.useForm();  
  const [dropdownValue, setdropdownValue] = useState('');
  const { Option } = Select;
  const [initialFormValues, setInitialFormValues] = useState({});
  const [metertypeOptionElect , setMeterTypeOptionElect] = useState([]);
  const [metertypeOptionGas , setMeterTypeOptionGas] = useState([]);
  const [productSupplierOptions , setProductSupplierOptions] = useState([]);
  const [current_supplier_gas , setCurrentSupplierGas] = useState([]);
  const [current_supplier_elec , setCurrentSupplierElectricity] = useState([]);
  
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const LIVE_BASE = process.env.REACT_APP_API_LIVE_URL;
  
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
  };

  const formItemLayoutTest = {
    labelCol: { xs: { span: 24 }, sm: { span: 30 }, md: { span: 8 }, lg: { span: 8 } },
    //wrapperCol: { xs: { span: 35 }, sm: { span: 20 }, md: { span: 50 }, lg: { span: 50 } }
  
  };

 

  const setInitialValues =(findUser)=>{
    //call api get data and set in  initialValues
    //setInitialFormValues(apiData);
    
     setInitialFormValues(findUser);
     
form.setFieldValue("lead_id",findUser.id);
form.setFieldValue("agent_name",findUser.attributes.agent_name);
form.setFieldValue("business_name",findUser.attributes.business_name);
form.setFieldValue("customer_name",findUser.attributes.customer_name);
form.setFieldValue("billing_address",findUser.attributes.billing_address);
form.setFieldValue("billing_postcode",findUser.attributes.billing_postcode);
form.setFieldValue("contact_number",findUser.attributes.contact_number);
form.setFieldValue("email_address",findUser.attributes.email_address);

//if(findUser.attributes.product_id === 1){
 // setProduct_id(findUser.attributes.product_id);
  //form.se("product_id",findUser.attributes.product_id);
 // form.setFieldValue("email_address",findUser.attributes.email_address);
//}


form.setFieldValue("elec_billing_name",findUser.attributes.electricity.billing_name);
form.setFieldValue("elec_supply_address",findUser.attributes.electricity.supply_address);
form.setFieldValue("elec_supply_postcode",findUser.attributes.electricity.supply_postcode);
form.setFieldValue("elec_current_supplier",findUser.attributes.electricity.current_supplier);
form.setFieldValue("elec_supply_number",findUser.attributes.electricity.supply_number);

form.setFieldValue("elec_billing_name",findUser.attributes.electricity.billing_name);
//form.setFieldValue("elec_contract_end_date",findUser.attributes.electricity.contract_end_date);
form.setFieldValue("elec_billing_amount",findUser.attributes.electricity.billing_amount);
form.setFieldValue("elec_standing_charge",findUser.attributes.electricity.standing_charge);
form.setFieldValue("elec_night_rate",findUser.attributes.electricity.night_rate);
form.setFieldValue("elec_capacity_charge",findUser.attributes.electricity.capacity_charge);
form.setFieldValue("elec_account_number",findUser.attributes.electricity.account_number);
form.setFieldValue("elec_msn",findUser.attributes.electricity.msn);
form.setFieldValue("elec_eac",findUser.attributes.electricity.eac);
form.setFieldValue("elec_metertype",findUser.attributes.electricity.metertype);
form.setFieldValue("elec_unit_rate",findUser.attributes.electricity.unit_rate);
form.setFieldValue("elec_eve_weekend",findUser.attributes.electricity.eve_weekend);
form.setFieldValue("elec_fit_charge",findUser.attributes.electricity.fit_charge);
form.setFieldValue("survey_feedback",findUser.attributes.survey_feedback);
form.setFieldValue("quality_feedback",findUser.attributes.quality_feedback);
form.setFieldValue("sales_feedback",findUser.attributes.sales_feedback);
// Check if the lead_status_list_id is 1, 2, 3, or 4
if ([2,5,6,7,8].includes(findUser.attributes.lead_status_list_id)) {
  // Set the form field value
  form.setFieldValue("lead_status_list_id", findUser.attributes.lead_status_list_id);
}
form.setFieldValue("elec_billing_frequency",findUser.attributes.electricity.billing_frequency);




form.setFieldValue("elec_metertype",findUser.relations.meter_type.electricity.id);

form.setFieldValue("elec_current_supplier",findUser.relations.supplier.electricity.id);
if (findUser?.attributes?.electricity?.supply_number) {

  const supplyNumber = findUser.attributes.electricity.supply_number;
  
  // Split the supply number into segments
  const SNR1C1 = supplyNumber.slice(0, 2);  // First 2 characters
  const SNR1C2 = supplyNumber.slice(2, 5);  // Next 3 characters
  const SNR1C3 = supplyNumber.slice(5, 8);  // Next 3 characters
  
  const SNR2C1 = supplyNumber.slice(8, 10);  // Next 2 characters (numeric)
  const SNR2C2 = supplyNumber.slice(10, 14); // Next 4 characters (numeric)
  const SNR2C3 = supplyNumber.slice(14, 18); // Next 4 characters (numeric)
  const SNR2C4 = supplyNumber.slice(18, 21); // Last 3 characters (numeric)
  
  
 

   form.setFieldValue("SNR1C1",SNR1C1);
   form.setFieldValue("SNR1C2",SNR1C2);
   form.setFieldValue("SNR1C3",SNR1C3);

   form.setFieldValue("SNR2C1",SNR2C1);
   form.setFieldValue("SNR2C2",SNR2C2);
   form.setFieldValue("SNR2C3",SNR2C3);
   form.setFieldValue("SNR2C4",SNR2C4);
}
//form.setFieldValue("elec_supply_number",findUser.attributes.electricity.supply_number);
form.setFieldValue("elec_billing_name",findUser.attributes.electricity.billing_name);
//form.setFieldValue("elec_contract_end_date",findUser.attributes.electricity.contract_end_date);


form.setFieldValue("gas_billing_name",findUser.attributes.gas.billing_name);
form.setFieldValue("gas_supply_address",findUser.attributes.gas.supply_address);
form.setFieldValue("gas_supply_postcode",findUser.attributes.gas.supply_postcode);
form.setFieldValue("gas_current_supplier",findUser.relations.supplier.gas.name);
form.setFieldValue("gas_mpr",findUser.attributes.gas.mpr);
form.setFieldValue("gas_billing_name",findUser.attributes.gas.billing_name);
//form.setFieldValue("gas_contract_end_date",findUser.attributes.gas.contract_end_date);
form.setFieldValue("gas_billing_amount",findUser.attributes.gas.billing_amount);
form.setFieldValue("gas_standing_charge",findUser.attributes.gas.standing_charge);
form.setFieldValue("gas_account_number",findUser.attributes.gas.account_number);
form.setFieldValue("gas_msn",findUser.attributes.gas.msn);
form.setFieldValue("gas_eac",findUser.attributes.gas.eac);
form.setFieldValue("gas_metertype",findUser.relations.meter_type.gas.name);
form.setFieldValue("gas_unit_rate",findUser.attributes.gas.unit_rate);
form.setFieldValue("selectedSupplyDetails","Gas")
if(findUser.attributes.electricity.contract_end_date){
  //form.setFieldValue("elec_contract_end_date",moment(findUser.attributes.electricity.contract_end_date))
  const rawDate = findUser?.attributes?.electricity?.contract_end_date;
  form.setFieldValue(
    "elec_contract_end_date",
    dayjs(rawDate, 'YYYY-MM-DD', true).isValid() ? dayjs(rawDate) : null
  );
}

if(findUser.attributes.gas.contract_end_date){
  //form.setFieldValue("gas_contract_end_date",moment(findUser.attributes.gas.contract_end_date))
  const rawDate = findUser?.attributes?.gas?.contract_end_date;
  form.setFieldValue(
    "gas_contract_end_date",
    dayjs(rawDate, 'YYYY-MM-DD', true).isValid() ? dayjs(rawDate) : null
  );
}
if(findUser.attributes.callback_date){
//form.setFieldValue("callback_date",moment(findUser.attributes.callback_date))
const rawDate = findUser?.attributes?.callback_date;
  form.setFieldValue(
    "callback_date",
    dayjs(rawDate, 'YYYY-MM-DD', true).isValid() ? dayjs(rawDate) : null
  );
}

const productId = findUser.attributes.product_id || 2;
form.setFieldValue("product_id",findUser.attributes.product_id);
setProduct_id(productId);


}


// Log the ID to the console
React.useEffect(() => {
  
}, [id]);

const clickIdFunction = async () => {

  try{
          const response = await clickId(id);
          let findUserResponse = response.data.data;
          setFindUserOK(findUserResponse);
          console.log("isEdit 123",isEdit);
          setInitialValues(findUserResponse);

          
  }
  catch(error){
   // return (<div><h1>No Data found</h1></div>)
   message.error("No Data found for :"+id)
    

  }

}

useEffect(()=>{

  loadMasterData().then(() => {
    
    //commented code is for implementing click link function
    console.log("log for id in useEffect"+id)
    if(id){
      clickIdFunction()
    }else{
      //do nothing
    }
    // if(isEdit === true){
    //   setInitialValues(findUser);
      
    // }else{
     
    //    //do nothing
    // }
  })
  .catch((error) => {
    console.error("Error in loadMasterData:", error);
  });
  
 
  },[]);

  const loadMasterData = async () => {
     const response =await masterSource();
     const meterOptGas = [];
     const meterOptElec = [];
     const productsSupplier = [];
     const currentSupplierGas = [];
     const currentSupplierElectricity = [];
     //response.data.suppliers.map(item=> currentSupplier.push({label: item.supplier_name,value: item.id}))
     response.data.products.map(item=> productsSupplier.push({label: item.product_name,value: item.id}))
     response.data.meter_types.map(item=> {
      if(item.product_id === 1){
      meterOptElec.push({label: item.meter_type,value: item.id})
     }else if(item.product_id === 2){
      meterOptGas.push({label: item.meter_type,value: item.id})
     } 
     }
     )

     response.data.suppliers.map(item=> {
      if(item.product_id === 1){
        currentSupplierElectricity.push({label: item.supplier_name,value: item.id})
        
     }else if(item.product_id === 2){
      currentSupplierGas.push({label: item.supplier_name,value: item.id})
     } 
     }
     )
     setMeterTypeOptionElect(meterOptElec);
     setMeterTypeOptionGas(meterOptGas);
     setProductSupplierOptions(productsSupplier);
     setCurrentSupplierGas(currentSupplierGas);
     setCurrentSupplierElectricity(currentSupplierElectricity);
     
  }

  

  const onChangeCheckBoxBillingAddress = (e) => {
    const checked = e.target.checked;
    if(product_id === ""){
      product_id = 2; // Default value for product_id
   }
    if (checked) {
      const billingAddress = form.getFieldValue("billing_address");
      if(product_id === 2){
        form.setFieldValue("gas_supply_address", billingAddress);
      }else{
        form.setFieldValue("elec_supply_address", billingAddress);
      }
     
    } else {
      if(product_id === 2){
        form.setFieldValue("gas_supply_address", "");// Clear the Billing Name field if unchecked
      }else{
        form.setFieldValue("elec_supply_address", "");// Clear the Billing Name field if unchecked
      }
       
    }
  };
  

  const onChangeCheckBoxBillingPostCode = (e) => {
    const checked = e.target.checked;
    if(product_id === ""){
      product_id = 2; // Default value for product_id
   }
    if (checked) {
      const billingPostcode = form.getFieldValue("billing_postcode");
      if(product_id === 2){
        form.setFieldValue("gas_supply_postcode", billingPostcode);
      }else{
        form.setFieldValue("elec_supply_postcode", billingPostcode);
      }
     
    } else {
      if(product_id === 2){
        form.setFieldValue("gas_supply_postcode", "");// Clear the Billing Name field if unchecked
      }else{
        form.setFieldValue("elec_supply_postcode", "");// Clear the Billing Name field if unchecked
      }
       
    }
  };



  const onChangeCheckBoxBillingName = (e) => {
    const checked = e.target.checked;
    if(product_id === ""){
       product_id = 2; // Default value for product_id
    }
    
    
    if (checked) {
      const businessName = form.getFieldValue("business_name");
      if(product_id === 2){
        
        form.setFieldValue("gas_billing_name", businessName);
      }else{
        
        form.setFieldValue("elec_billing_name", businessName);
      }
     
    } else {
      if(product_id === 2){
        
        form.setFieldValue("gas_billing_name", "");// Clear the Billing Name field if unchecked
      }else{
        
        form.setFieldValue("elec_billing_name", "");// Clear the Billing Name field if unchecked
      }
       
    }
  };

  
  function SurveyLeadUpdate(requestBody){
    const finalSupplyNumber = requestBody.elec_supply_number || findUserOK?.attributes?.electricity?.supply_number;
    
    
    setSupplyNumber(supplyNumber)
    const id = findUserOK.id;
    const requestBodyFinal = {...requestBody,
      gas_current_supplier:findUserOK.attributes.gas.current_supplier,
      gas_metertype:findUserOK.attributes.gas.metertype,
      product_id:product_id,
      elec_supply_number:finalSupplyNumber,
    //  elec_supply_number:findUser.attributes.electricity.supply_number


    }
    
    
    const LEAD_UPDATE_URL = `${LIVE_BASE}/leads/`+id;
    axios.put(LEAD_UPDATE_URL,requestBodyFinal).then((res) => {
      notification.success({message:"Successfully updated the agent details !"});
      form.resetFields();
      localStorage.removeItem('isEdit');
    
    
  }).catch((error) => {
    const errorList = [];
    
    
   
   const errorsName = Object.values(error.response.data.errors).flat();
   setErrors(errorsName);
   showModal();
  });
  
  } 
  const handleDropdownChange = (e) => {
    setdropdownValue(items.key);
  };
  const onFinish = (values) => {
    
    const callback_dateValue = values.callback_date ? moment(new Date(values.callback_date)).format("YYYY-MM-DD"):undefined;
    
    const gas_contract_end_dateValue = values.gas_contract_end_date? moment(new Date(values.gas_contract_end_date)).format("YYYY-MM-DD"):undefined;
    const elec_contract_end_dateValue = values.elec_contract_end_date? moment(new Date(values.elec_contract_end_date)).format("YYYY-MM-DD"):undefined;
   


  const request = values;

  const convertValuesToUpperCase = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [key, typeof value === 'string' ? key ==='email_address' ? value.toLowerCase() :value.toUpperCase() : value])
    );
  };

  let  finalRequest ={
    ...values,
    callback_date: callback_dateValue,
    gas_contract_end_date: gas_contract_end_dateValue,
    elec_contract_end_date:  elec_contract_end_dateValue,
    product_id: product_id,
    elec_supply_number:supplyNumber
  }

  let finalRequestUpperCase = convertValuesToUpperCase(finalRequest);
  finalRequest = finalRequestUpperCase;

  const queryParams = new URLSearchParams(location.search);
  const isEditParam = queryParams.get('isEdit');

  // Set isEdit to true only if the param is exactly "true"
  const isEditQP = isEditParam === 'true';
if(isEditQP){
  const request = values;
  
  const  finalRequestUpdate ={
    ...values,
    callback_date: callback_dateValue,
    gas_contract_end_date: gas_contract_end_dateValue,
    elec_contract_end_date:  elec_contract_end_dateValue,
    product_id: product_id,
    elec_supply_number:supplyNumber
    

  }
  SurveyLeadUpdate(finalRequestUpdate);
  
}else{
  
  surveyLeadSave(finalRequest).then((res) => {
    notification.success({message:"Successfully added !"});
    form.resetFields();
  
  
}).catch((error) => {
  const errorList = [];
  
  
 
 const errorsName = Object.values(error.response.data.errors).flat();
 setErrors(errorsName);
 showModal();
});
}
 
  };
  const [evalue, setEvalue] = useState('');
  const [gvalue, setGvalue] = useState('');
  const [value, setValue] = useState('');
  const [fvalue, setFValue] = useState('');

  const handleNewChange = (e) => {
    setValue(e.target.value);
  };

  const handleFrequency = (value) => {
    setFValue(value);
    // Optionally log the selected value
  };

  const handleElecMetreType = (e) => {
    setEvalue(e.target.value);
  };

  const handleGasMetreType = (e) => {
    setGvalue(e.target.value);
  };

  

  // const [Elec_contract_end_date, setDateECED] = useState(new Date().toLocaleDateString('fr-FR'));
  // const [Gas_contract_end_date, setDateGCED] = useState(new Date().toLocaleDateString('fr-FR'));
  // const [Callback_date, setDateCD] = useState(new Date().toLocaleDateString('fr-FR'));
  // const products =[
  //   {
  //     product_id:'1',  
  //     label: 'Gas'
  //   },
  //   {
  //     product_id:'2',
  //     label: 'Electricity'
  //   }
  // ]
  const meterTypeElectricity =[
    {
      product_id:'1',
      label: 'Economy'
    },
    {
      product_id:'1',
      label: 'Standard'
    }]
  const items = [
    {
      label: 'Call Back',
      key: '1',
    },
    {
      label: 'Plain Servey',
      key: '2',
    },
    {
      label: 'Quality',
      key: '3',
    },
    {
      label: 'Quality Low Eac',
      key: '4',
    },
  ];

 
  let [product_id, setProduct_id] = useState('');
  const handleOnChange1 = (event) => {
    //const value = event.target.value;
    setProduct_id(event);
    
    //form.setFieldValue('product_id',1);
  //  
  }
const handleOnChange = (event) => {
  
  setProduct_id(event);
  
  //form.setFieldValue('product_id',1);
  
}
const [inputValue, setInputValue] = useState("inputValue");
  const handleInput = (input) => {
    const capsValue = input.target.value.toUpperCase();
    setInputValue(capsValue);
  }

  const handleInputChange = () => {
    const snr1c1 = form.getFieldValue("SNR1C1") || "";
    const snr1c2 = form.getFieldValue("SNR1C2") || "";
    const snr1c3 = form.getFieldValue("SNR1C3") || "";
    const snr2c1 = form.getFieldValue("SNR2C1") || "";
    const snr2c2 = form.getFieldValue("SNR2C2") || "";
    const snr2c3 = form.getFieldValue("SNR2C3") || "";
    const snr2c4 = form.getFieldValue("SNR2C4") || "";

    // Combine values, ignoring empty strings
    const combinedValue = [snr1c1, snr1c2, snr1c3, snr2c1, snr2c2, snr2c3, snr2c4]
        .filter(value => value !== undefined && value !== null && value !== "")
        .join("");

    setSupplyNumber(combinedValue);
    
};

// const divDisplay = ()=>{
//     let result;
//     supplyDeatils === "electricity" 
//     ? (result = <ElectricityComponent ref={ref1}  />)
//      : (result = <GasComponent  ref={ref2} />);
//     return result;
// }

const testData= [{
  "agent_id": 1,
  "business_name": "Sample Business",
  "customer_name": "John Doe",
  "billing_address": "123 Main Street",
  "billing_postcode": "12345",
  "contact_number": "1234567890",
  "email_address": "johndoe@example.com",
  "product_id": 1,
  "elec_billing_name": "aaa",
  "elec_supply_address": "test",
  "elec_supply_postcode": "54321",
  "elec_current_supplier": 1,
  "elec_supply_number": "SUPPLY123",
  "elec_contract_end_date": "2024-12-31",
  "elec_billing_amount": 200.50,
  "elec_standing_charge": 30,
  "elec_night_rate": 10,
  "elec_capacity_charge": 15,
  "elec_account_number": "ACCOUNT123",
  "elec_msn": "MSN123",
  "elec_eac": 5000,
  "elec_metertype": 1,
  "elec_unit_rate": 20,
  "elec_eve_weekend": 15,
  "elec_fit_charge": 5,
  "callback_date": "2024-06-16",
  "lead_status_list_id": 1,
  "sales_status_list_id": 1
}
]

// function loadData(){
//   form.setFieldValue('product_id',1);
//   form.setFieldValue('callback_date',Callback_date);
//   form.setFieldValue('gas_contract_end_date',Gas_contract_end_date);
// }
 

const handleChildValidation = (values)=>{
 const val1 = ref1.current?.handleValidation();
 const val2 = ref2.current?.handleValidation();
 
}
const [supplyValue, setSupplyValue] = useState("Select Supply Details");
// const formItemLayoutTest = {
//   labelCol:{ span: 10 },
//   wrapperCol:{ span: 24 }
// }
// const formItemLayout = {
//   labelCol: { xs: { span: 24 }, sm: { span: 30 }, md: { span: 8 }, lg: { span: 8 } },
//   wrapperCol: { xs: { span: 35 }, sm: { span: 20 }, md: { span: 50 }, lg: { span: 50 } }

// };
// const tailFormItemLayout = {
//   wrapperCol: { xs: { span: 24 }, sm: { span: 12, offset: 12 }, md: { span: 12, offset: 8 }, lg: { span: 12, offset: 8 } }
// };
  return (
    <div className="card" style={{background:"linear-gradient(to bottom, Transparente 0%,Transparente 50%,red 50%,red 100%)"}}>
    <><Form
      name="register"
      onFinish={onFinish}
      form={form}      
      initialValues={{
        
        ...initialFormValues
      }}
     
     //{...formItemLayoutTest}

      style={{
        maxWidth: '100%',
      }} 
      scrollToFirstError
    >
      
      <Divider variant="dotted" style={{ borderColor: '#7cb305'}}>Lead Details</Divider>

      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}>
      <Form.Item 
        name="agent_name"
        label="Agent Name"
        style={{ width: '45%' }}
        labelCol={{ span: 9 }} // Label takes the full width of the column
        wrapperCol={{ span: 13 }} // Input takes the full width of the column
      >
        <Input disabled style={{borderColor:'forestgreen', color:'black',textTransform:'uppercase'}} placeholder={user.name} readOnly />
      </Form.Item>
      <Form.Item 
        name="lead_id"
        label="Lead ID"
        style={{ width: '45%' }}
        labelCol={{ span: 6 }} // Label takes the full width of the column
        wrapperCol={{ span: 13 }} // Input takes the full width of the column
      >
        <InputNumber readOnly disabled style={{width:'100%', borderColor:'forestgreen', color:'black'}} />
      </Form.Item>
    </div>

    <Form.Item
      name="business_name"
      label="Business Name"
      className="custom-form-item"
      style={{ width: '70%' }}
      labelCol={{ span: 4 }} // Label takes the full width of the column
      wrapperCol={{ span: 18 }} // Input takes the full width of the column
      rules={[{ toUpperCase : true }]}
    >
      <Input style={{borderColor:'forestgreen', fontStretch:'expanded',textTransform:'uppercase'}} 
       />
    </Form.Item>

    <Form.Item
      name="customer_name"
      label="Customer Name"
      className="custom-form-item"
      style={{ width: '70%' }}
      labelCol={{ span: 4 }} // Label takes the full width of the column
      wrapperCol={{ span: 18 }} // Input takes the full width of the column
    >
      <Input style={{borderColor:'forestgreen', fontStretch:'expanded',textTransform:'uppercase'}}  />
    </Form.Item>

    <Form.Item
      name="billing_address"
      label="Billing Address"
      className="custom-form-item"
      style={{ width: '70%' }}
      labelCol={{ span: 4 }} // Label takes the full width of the column
      wrapperCol={{ span: 18 }} // Input takes the full width of the column
    >
      <Input style={{borderColor:'forestgreen', fontStretch:'expanded',textTransform:'uppercase'}}  />
    </Form.Item>

    <div className="custom-form-item" style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}>
    <Form.Item
        name="billing_postcode"
        label="Billing Postcode"
        className="custom-form-item"
       // style={{fontFamily:"serif"}}

        style={{ width: '45%' }}
        labelCol={{ span: 9 }} // Label takes the full width of the column
        wrapperCol={{ span: 13 }} // Input takes the full width of the column
        
      >
        <Input 
        maxLength={9}
        style={{borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}
       // onKeyUp={e => e.target.value = e.target.value.toUpperCase()}
       />
      </Form.Item>
      
      <Form.Item
        name="contact_number"
        label="Contact Number"
        className="custom-form-item"
        style={{ width: '45%' }}
        labelCol={{ span: 7 }} // Label takes the full width of the column
        wrapperCol={{ span: 11 }} // Input takes the full width of the column
       // style={{marginLeft:'8%',fontFamily:"serif"}}
        rules={[
          {
           // required: true,
           // message: 'Please input your contact number!',
          },]}  
      >
         <Input 
         pattern="\d{10}"
        title="Please enter 10 digits numeric only."
         style={{width:'114%',borderColor:'forestgreen',fontStretch:'expanded'}} maxLength={10}/>
      </Form.Item> 
</div>
       <Form.Item
        name="email_address"
        label="Email Address"
        className="custom-form-item"
        style={{fontFamily:"serif",width:'70%'}}
        labelCol={{ span: 4 }} // Label takes the full width of the column
        wrapperCol={{ span: 18 }} // Input takes the full width of the column
        rules={[
          {
            type: 'email',
            message: 'The input is not valid Email Address!',
          },
          {
            //required: true,
           // message: 'Please input your Email Address',
          },
        ]}
      >
        <Input style={{borderColor:'forestgreen',fontStretch:'expanded'}}/>
      </Form.Item>
   
</div>
    
      <Flex style={{paddingBottom:0}}>
      
      <Form.Item
        name="product_id"
        label="Supply Details"
        className="custom-form-item"
        
        style={{marginLeft:'32%',fontFamily:"serif",borderColor:'forestgreen'}}
        // rules={[
        //   {
        //     message: 'Please select Supply Details!',
        //   },
        // ]}
      >
 
    { 
      <Select 
      name = "selectedSupplyDetails"
      defaultValue="Gas"

      style={{  marginLeft:'40px',width:'300px',borderColor:'forestgreen'}} 
       onChange={handleOnChange1}
      
      options = { productSupplierOptions}/>
    }
      
      </Form.Item>
      </Flex>
   
      <div className="custom-form-item" >
        {
        product_id === 1
    ? (<>  
    
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '70%' }}>
    <Form.Item 
      name="elec_billing_name"
      label="Billing Name"
      style={{ fontFamily: "serif", borderColor: 'forestgreen',width:'62%' ,marginLeft:'60px'}}
      //labelCol={{ span: 14 }} // Label takes the full width of the column
        //wrapperCol={{ span: 25 }} // Input takes the full width of the column
    >
      <Input 
        style={{ borderColor: 'forestgreen', fontStretch: 'expanded' ,textTransform:'uppercase'}} 
        
      />
    </Form.Item>
    <Checkbox 
      style={{ fontFamily: "serif", borderColor: 'forestgreen', marginRight:'100px',marginBottom:'22px'}} 
      onChange={onChangeCheckBoxBillingName}
    > Same as Business Name</Checkbox>
  </div>
  
</div>

<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '72%' }}>
<Form.Item
      name="elec_supply_address"
      label="Supply Address"
     // style={{display: 'flex',flexDirection: 'row',justifyContent:'flex-start',textAlign:'right',lineHeight:'26px'}}
     style={{ fontFamily: "serif", borderColor: 'forestgreen',width:'62%' ,marginLeft:'55px'}}
      rules={[
        {
         // required: true,
         // message: 'Please input your Supply Address!',
        },
      ]}
    >
      <Input 
      style={{borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}
      />
      </Form.Item>
      <Checkbox
         style={{ fontFamily: "serif", borderColor: 'forestgreen', marginRight:'107px',marginBottom:'22px'}} 
          onChange={onChangeCheckBoxBillingAddress}>Same as Billing Address</Checkbox>
    
  </div></div>

<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '72%' }}>
  <Form.Item
      name="elec_supply_postcode"
      label="Supply Postcode"
      style={{ fontFamily: "serif", borderColor: 'forestgreen',width:'63%' ,marginLeft:'45px'}}
      
  
    >
      <Input 
      
      maxLength={9}
      //  pattern="[A-Za-z0-9]{8}"
        title="Please enter 8 digits alphanumeric only."
      style={{flex: '0 0 200px',borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}/>
      </Form.Item>
    <Checkbox 
      style={{ fontFamily: "serif", borderColor: 'forestgreen', marginRight:'100px',marginBottom:'22px'}} 
      onChange={onChangeCheckBoxBillingPostCode}
    > Same as Billing PostCode</Checkbox>
  </div></div>
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}>
  <Form.Item
      name="elec_current_supplier"
      label="Current Supplier"
      labelCol={{ span: 13 }} // Label takes the full width of the column
      >
    <Select placeholder="Select Supplier" 
    style={{ width: '200%' ,marginLeft:'10px'}}
    
    
    options = {current_supplier_elec}
  />
    </Form.Item>
    <Space>{" "}</Space>
    <Form.Item
      name="elec_account_number"
      label="Account Number"
   //   style={{marginLeft:'15%',fontFamily:"serif",width:'400px'}}
        style={{ width: '45%',marginRight:'120px' }}
        labelCol={{ span: 12 }} // Label takes the full width of the column
        wrapperCol={{ span: 13 }} // Input takes the full width of the column 
    >
       <Input 
       
       style={{width:'122%',flex: '0 0 200px',borderColor:'forestgreen',textTransform:'uppercase'}}/>
    </Form.Item>
     
    </div></div>
      
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
  <div style={{ display: 'flex', flexDirection: 'column', width: '70%' }}>
  <table><tr>
      <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' ,width:'100%'}}>
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' ,width:'80%'}}>
      <Form.Item
        name="elec_supply_number"
        label="Supply Number"
        style={{ fontFamily: "serif",marginLeft:'15px' }}
      ></Form.Item>

      <Row gutter={8} style={{ flex: 1 ,marginLeft:'10px'}}>
        <Col span={8}>
          <Form.Item name="SNR1C1" style={{ fontFamily: "serif" }}>
            <Input
              maxLength={2}
              
              style={{ borderColor: 'forestgreen', textAlign: 'center' ,width:'80px',textTransform:'uppercase'}}
              placeholder="XX"
              onChange={handleInputChange}
              pattern="[A-Za-z0-9]{2}"
              title="Please enter 2 alphanumeric characters."
              
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="SNR1C2" style={{ fontFamily: "serif" }}>
            <Input
              maxLength={3}
              style={{ borderColor: 'forestgreen', textAlign: 'center',width:'80px' ,textTransform:'uppercase'}}
              placeholder="XXX"
              onChange={handleInputChange}
              pattern="[A-Za-z0-9]{3}"
              title="Please enter 3 alphanumeric characters."
              
            />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item name="SNR1C3" style={{ fontFamily: "serif" }}>
            <Input
              maxLength={3}
              style={{ borderColor: 'forestgreen', textAlign: 'center' ,width:'80px',textTransform:'uppercase'}}
              placeholder="XXX"
              onChange={handleInputChange}
              pattern="[A-Za-z0-9]{3}"
              title="Please enter 3 alphanumeric characters."
              
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
    </td><td style={{ justifyContent: 'space-between', alignItems: 'center' ,width:'42%'}}><Form.Item
        name="elec_msn"
        label="MSN"
        style={{  fontFamily: "serif" }}
      >
        <Input
          style={{ borderColor: 'forestgreen', fontStretch: 'expanded' ,width:'78%',marginRight:'59px',textTransform:'uppercase'}}
          
        />
      </Form.Item></td></tr>
      <tr>
      
      <td>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',marginLeft:'140px' ,width:'80%'}}>
      <Row gutter={8} style={{ flex: 1 }}>
        <Col span={4}>
          <Form.Item name="SNR2C1" style={{ fontFamily: "serif" }}>
            <Input
              maxLength={2}
              style={{ borderColor: 'forestgreen', textAlign: 'center',width:'60px' }}
              placeholder="XX"
              onChange={handleInputChange}
              pattern="\d{2}"
              title="Please enter 2 numeric digits."
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="SNR2C2" style={{ fontFamily: "serif" }}>
            <Input
              maxLength={4}
              style={{ borderColor: 'forestgreen', textAlign: 'center' ,width:'60px'}}
              placeholder="XXXX"
              onChange={handleInputChange}
              pattern="\d{4}"
              title="Please enter 4 numeric digits."
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="SNR2C3" style={{ fontFamily: "serif" }}>
            <Input
              maxLength={4}
              style={{ borderColor: 'forestgreen', textAlign: 'center',width:'60px' }}
              placeholder="XXXX"
              onChange={handleInputChange}
              pattern="\d{4}"
              title="Please enter 4 numeric digits."
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name="SNR2C4" style={{ fontFamily: "serif" ,width:'60px'}}>
            <Input
              maxLength={3}
              style={{ borderColor: 'forestgreen', textAlign: 'center' }}
              placeholder="XXX"
              onChange={handleInputChange}
              pattern="\d{3}"
              title="Please enter 3 numeric digits."
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
    </td>
    <td style={{textAlign: 'left',verticalAlign:'top',fontSize:'14px'}}><div>
    {"Supply Number: "+supplyNumber.slice(0, 8) + ' ' + supplyNumber.slice(8)}
      </div></td>
      
      </tr></table>
   

    
    
  </div>
</div>

    {/* <div>Combined Supply Number: {supplyNumber}</div> */}
      <div className="side-by-side" style={{marginLeft:'200px'}}>
      <table>
        <tr>
          <td><Form.Item
      name="elec_contract_end_date"
      label="Contract End Date">
     <DatePicker
    format="DD-MM-YYYY"
    style={{width:'125%',flex: '0 0 200px',borderColor:'forestgreen',marginLeft:'10px'}}
  />
    </Form.Item></td>
        <td>
          <Form.Item
      name="elec_eac"
      label="EAC"
      style={{marginLeft:'200px',fontFamily:"serif"}}
      
    >
       <Input  
        style={{width:'150px',flex: '0 0 200px',borderColor:'forestgreen',textTransform:'uppercase'}}/>
    
    </Form.Item>
    </td>
        <td>
        <div style={{ marginBottom: '20px',fontSize:'14px' }}>
        (kWh Annually)
      </div></td>
        </tr></table>  
      

    
    
    
    </div>
     {/* <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> 
      <Form.Item
      name="elec_billing_amount"
      label="Billing Amount"
      //style={{marginRight:'22%',fontFamily:"serif"}}
      style={{ width: '100px' ,marginLeft:'233px'}}
     // labelCol={{ span: 9 }} // Label takes the full width of the column
     // wrapperCol={{ span: 13 }} // Input takes the full width of the column
    
    >
      <Input 
      style={{width:'150px',borderColor:'forestgreen',textTransform:'uppercase',marginLeft:'10px'}}  
      
      />
    </Form.Item>

    <Form.Item  name="billing_frequency"
    
      style={{marginLeft:'170px'}}
      onChange={handleFrequency}>
      <Select placeholder="Select frequency" style={{ width: '150px' }} options = {[
    {
      label: 'Monthly',
      value: 'monthly',
    },
    {

      label: 'Quarterly',
      value: 'quarterly',
    },
    {
      label: 'Yearly',
      value: 'yearly',
    },

  ]}/></Form.Item>
    <Form.Item
      name="elec_metertype"
      label="Meter Type"
      style={{marginLeft:'70px',fontFamily:"serif"}}
      labelCol={{ span: 9 }} // Label takes the full width of the column
      wrapperCol={{ span: 13 }} // Input takes the full width of the column
      onChange={handleElecMetreType}
    >
      <Select placeholder="Select Options" 
      style={{borderColor:'forestgreen',width:'230px',marginLeft:'5px'}}
      options = {metertypeOptionElect}
  /></Form.Item>
    </div> */}



    <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> 
      <Form.Item
      name="elec_billing_amount"
      label="Billing Amount"
      //style={{marginRight:'22%',fontFamily:"serif"}}
      style={{ width: '100px' ,marginLeft:'233px'}}
     // labelCol={{ span: 9 }} // Label takes the full width of the column
     // wrapperCol={{ span: 13 }} // Input takes the full width of the column
    
    >
      <Input 
      style={{width:'150px',borderColor:'forestgreen',textTransform:'uppercase',marginLeft:'10px'}}  
      
      />
    </Form.Item>

    <Form.Item  name="elec_billing_frequency"
      style={{marginLeft:'170px'}}
      onChange={handleFrequency}>
      <Select placeholder="Select frequency" style={{ width: '150px' }} options = {[
    {
      label: 'Monthly',
      value: 'monthly',
    },
    {

      label: 'Quarterly',
      value: 'quarterly',
    },
    {
      label: 'Yearly',
      value: 'yearly',
    },

  ]}/></Form.Item>
    <Form.Item
      name="elec_metertype"
      label="Meter Type"
      style={{marginLeft:'70px',fontFamily:"serif"}}
      labelCol={{ span: 9 }} // Label takes the full width of the column
      wrapperCol={{ span: 13 }} // Input takes the full width of the column
      onChange={handleElecMetreType}
    >
      <Select placeholder="Select Options" 
      style={{borderColor:'forestgreen',width:'230px',marginLeft:'5px'}}
      options = {metertypeOptionElect}
  /></Form.Item>
    </div>
   
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> 
      <Form.Item
      name="elec_standing_charge"
      label="Standing Charge"
      style={{marginLeft:'25%',fontFamily:"serif"}}>
      <Input 
       type="text" 
       pattern="^\d*\.?\d*$" 
       title="Please enter a valid number" 
      style={{marginRight:'115px',marginLeft:'2px',width:'80px',flex: '0 0 200px',borderColor:'forestgreen',textTransform:'uppercase'}}  />
    </Form.Item>
    <FormItem>
      <div  style={{marginRight:'32px',marginLeft:'5px'}}>(p/day)</div>
    </FormItem>

    <Form.Item
      name="elec_unit_rate"
      label="Weekday Unit Rates"
      style={{fontFamily:"serif"}}>
        
       <Input 
       type="text" 
       pattern="^\d*\.?\d*$" 
       title="Please enter a valid number" 
       style={{borderColor:'forestgreen',width:'80px',marginRight:'135px',marginLeft:'1px',textTransform:'uppercase'}}/>
    </Form.Item>
    <FormItem>
      <div style={{marginRight:'40px',marginLeft:'10px'}}>(p/kWh)</div>
    </FormItem>
    <Form.Item
      name="elec_night_rate"
      label="Night Rate"
     // style={{marginLeft:'90px'}}
    >
      <Input
      type="text" 
      pattern="^\d*\.?\d*$" 
      title="Please enter a valid number" 
      style={{borderColor:'forestgreen',width:'80px',marginRight:'75px',textTransform:'uppercase'}}    />
    </Form.Item>
    <FormItem>
      <div style={{marginLeft:'10px'}}>(p/kWh)</div>
    </FormItem>

    </div>
    <div>
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> 
     

    <Form.Item
      name="elec_eve_weekend"
      label="Eve Weekend"
      style={{marginLeft:'27%',fontFamily:"serif"}}>
       <Input 
       type="text" 
       pattern="^\d*\.?\d*$" 
       title="Please enter a valid number" 
       style={{borderColor:'forestgreen',width:'75px',marginRight:'85px',textTransform:'uppercase'}}/>
    </Form.Item>
    <FormItem>
      <div style={{marginLeft:'15px',marginRight:'30px'}}>(p/kWh)</div>
    </FormItem>
    <Form.Item
      name="elec_capacity_charge"
      label="Capacity Charge"
     
    >
      <Input 
      type="text" 
      pattern="^\d*\.?\d*$" 
      title="Please enter a valid number" 
      style={{width:'75px',borderColor:'forestgreen',marginRight:'120px',textTransform:'uppercase'}}/>
    </Form.Item>
    <FormItem>
      <div style={{marginRight:'10px'}}>(p/kVa/day)</div>
    </FormItem>

    <Form.Item
      name="elec_fit_charge"
      label="FIT Charge/Offpeak"
      style={{marginLeft:'2%',fontFamily:"serif"}}
      
      
    >
       <Input 
       type="text" 
       pattern="^\d*\.?\d*$" 
       title="Please enter a valid number" 
       style={{borderColor:'forestgreen',width:'75px',marginRight:'130px',textTransform:'uppercase'}}/>
    </Form.Item>
    <FormItem>
      <div style={{marginLeft:'10px'}}>(p/kWh)</div>
    </FormItem>
    </div></div>
    
    
    </>
   )
     : (
      
     <> 
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '70%' }}>
    <Form.Item 
      name="gas_billing_name"
      label="Billing Name"
      style={{ fontFamily: "serif", borderColor: 'forestgreen',width:'62%' ,marginLeft:'60px'}}
      //labelCol={{ span: 14 }} // Label takes the full width of the column
        //wrapperCol={{ span: 25 }} // Input takes the full width of the column
    >
      <Input 
        style={{ borderColor: 'forestgreen', fontStretch: 'expanded' ,textTransform:'uppercase'}} 
        
      />
    </Form.Item>
    <Checkbox 
      style={{ fontFamily: "serif", borderColor: 'forestgreen', marginRight:'100px',marginBottom:'22px'}} 
      onChange={onChangeCheckBoxBillingName}
    > Same as Business Name</Checkbox>
  </div>
  
</div>
<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '72%' }}>
<Form.Item
      name="gas_supply_address"
      label="Supply Address"
     // style={{display: 'flex',flexDirection: 'row',justifyContent:'flex-start',textAlign:'right',lineHeight:'26px'}}
     style={{ fontFamily: "serif", borderColor: 'forestgreen',width:'62%' ,marginLeft:'55px'}}
      rules={[
        {
         // required: true,
         // message: 'Please input your Supply Address!',
        },
      ]}
    >
      <Input 
      style={{borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}
      />
      </Form.Item>
      <Checkbox
         style={{ fontFamily: "serif", borderColor: 'forestgreen', marginRight:'107px',marginBottom:'22px'}} 
          onChange={onChangeCheckBoxBillingAddress}>Same as Billing Address</Checkbox>
    
  </div></div>
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '72%' }}>
  <Form.Item
      name="gas_supply_postcode"
      label="Supply Postcode"
      style={{ fontFamily: "serif", borderColor: 'forestgreen',width:'63%' ,marginLeft:'45px'}}
    //  style={{display: 'flex',flexDirection: 'row',justifyContent:'flex-start',textAlign:'right',lineHeight:'26px'}}
      // rules={[
      //   {
      //   //  required: true,
      //   //  message: 'Please input your Supply Postcode!',
      //     toUpperCase : true,
      //   },
      // ]}
    >
      <Input 
      maxLength={9}
    //  pattern="[A-Za-z0-9]{8}"
      title="Please enter 8 digits alphanumeric only."
      
      style={{flex: '0 0 200px',borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}/>
      </Form.Item>
    <Checkbox 
      style={{ fontFamily: "serif", borderColor: 'forestgreen', marginRight:'100px',marginBottom:'22px'}} 
      onChange={onChangeCheckBoxBillingPostCode}
    > Same as Billing PostCode</Checkbox>
  </div></div>
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}>
  <Form.Item
      name="gas_current_supplier"
      label="Current Supplier"
      labelCol={{ span: 13 }} // Label takes the full width of the column
      >
    <Select placeholder="Select Supplier" 
    style={{ width: '200%' ,marginLeft:'10px'}}
    
    //wrapperCol={{ span: 13 }} // Input takes the full width of the column 
   // labelCol={{ span: 9 }} // Label takes the full width of the column
   // wrapperCol={{ span: 13 }} // Input takes the full width of the column
    //style={{ marginRight:'30px',width: 150 ,borderColor:'forestgreen',backgroundColor:'ButtonShadow'}} 
    
    options = {current_supplier_gas}
  />
    </Form.Item>
    <Space>{" "}</Space>
    <Form.Item
      name="gas_account_number"
      label="Account Number"
   //   style={{marginLeft:'15%',fontFamily:"serif",width:'400px'}}
        style={{ width: '45%',marginRight:'120px' }}
        labelCol={{ span: 12 }} // Label takes the full width of the column
        wrapperCol={{ span: 13 }} // Input takes the full width of the column 
    >
       <Input 
       
       style={{width:'122%',flex: '0 0 200px',borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}/>
    </Form.Item>
     
    </div></div>

    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}>
  <Form.Item
      name="gas_mpr"
      label="MPR"
      rules={[
        {
          maxLength: 10,
        },
      ]}
      style={{ width: '45%',marginRight:'165px',marginLeft:'10px' }}
        labelCol={{ span: 12 }} // Label takes the full width of the column
        wrapperCol={{ span: 13 }} // Input takes the full width of the column 
      >
   <Input 
       style={{width:'170%',borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}/>
    </Form.Item>
    <Space>{" "}</Space>
    <Form.Item
      name="gas_msn"
      label="MSN"
   //   style={{marginLeft:'15%',fontFamily:"serif",width:'400px'}}
        style={{ width: '45%',marginRight:'185px' }}
        labelCol={{ span: 12 }} // Label takes the full width of the column
        wrapperCol={{ span: 13 }} // Input takes the full width of the column 
    >
       <Input 
       
       style={{width:'180%',borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}/>
    </Form.Item>
     
    </div></div>
    <div className="side-by-side" style={{marginLeft:'200px'}}>
      <table>
        <tr>
          <td><Form.Item
      name="gas_contract_end_date"
      label="Contract End Date">
     <DatePicker
    format="DD-MM-YYYY"
    style={{width:'125%',flex: '0 0 200px',borderColor:'forestgreen',marginLeft:'10px'}}
  />
    </Form.Item></td>
        <td><Form.Item
      name="gas_eac"
      label="EAC"
      style={{marginLeft:'205px',fontFamily:"serif"}}
      
    >
       <Input  
       style={{width:'150px',flex: '0 0 200px',borderColor:'forestgreen',fontStretch:'expanded',textTransform:'uppercase'}}/>
    
    </Form.Item></td>
        <td>
        <div style={{ marginBottom: '20px',fontSize:'14px' }}>
        (kWh Annually)
      </div></td>
        </tr></table>  </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> 
      <Form.Item
      name="gas_billing_amount"
      label="Billing Amount"
      //style={{marginRight:'22%',fontFamily:"serif"}}
      style={{ width: '75%' ,marginLeft:'235px'}}
      labelCol={{ span: 9 }} // Label takes the full width of the column
      wrapperCol={{ span: 13 }} // Input takes the full width of the column
    
    >
      <Input 
      style={{marginLeft:'15px',marginRight:'10px',width:'140%',flex: '0 0 200px',borderColor:'forestgreen'}}  
      onInput={e => e.target.value = e.target.value.toUpperCase()}
      />
    </Form.Item>

    <Form.Item
      name="gas_metertype"
      label="Meter Type"
      style={{marginLeft:'15%',fontFamily:"serif",width: '55%'}}
      labelCol={{ span: 9 }} // Label takes the full width of the column
      wrapperCol={{ span: 13 }} // Input takes the full width of the column
      onChange={handleGasMetreType}
    >
      <Select placeholder="Select Options" 
      style={{flex: '0 0 200px',borderColor:'forestgreen',width:'280px'}}
      options = {[
        {
          label: 'Gas',
          value: '3',
        }
      ]}/>
      </Form.Item>
    </div>
       
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> 
      <Form.Item
      name="gas_standing_charge"
      label="Standing Charge"
      style={{marginLeft:'25%',fontFamily:"serif"}}>
      <Input 
      type="text" 
      pattern="^\d*\.?\d*$" 
      title="Please enter a valid number" 
      style={{marginRight:'100px',marginLeft:'2px',width:'200px',flex: '0 0 200px',borderColor:'forestgreen',textTransform:'uppercase'}}  />
    </Form.Item>
    <FormItem>
      <div  style={{marginLeft:'25px'}}>(p/day)</div>
    </FormItem>

    <Form.Item
      name="gas_unit_rate"
      label="Unit Rate"
      style={{fontFamily:"serif",marginLeft:'68px'}}>
        
       <Input 
       type="text" 
       pattern="^\d*\.?\d*$" 
       title="Please enter a valid number" 
       style={{borderColor:'forestgreen',width:'200px',marginRight:'70px',marginLeft:'1px',textTransform:'uppercase'}}/>
    </Form.Item>
    <FormItem>
      <div style={{marginRight:'44px',marginLeft:'10px'}}>(p/kWh)</div>
    </FormItem>
   

    </div>
    </>)
}
        </div>
     
        <Form.Item
        name="survey_feedback"
        label="Agent Feedback"
        style={{ width: '70%' ,marginLeft:'15%'}}
        labelCol={{ span: 4 }} // Label takes the full width of the column
        wrapperCol={{ span: 18 }} // Input takes the full width of the column
      >
        <Input.TextArea disabled readOnly 
        onInput={e => e.target.value = e.target.value.toUpperCase()}
        style={{borderColor:'forestgreen',color:'black'}}/>
      </Form.Item>

      <Form.Item
        name="quality_feedback"
        label="Quality Feedback"
        style={{ width: '70%' ,marginLeft:'15%'}}
        labelCol={{ span: 4 }} // Label takes the full width of the column
        wrapperCol={{ span: 18 }} // Input takes the full width of the column
      >
        <Input.TextArea 
        onInput={e => e.target.value = e.target.value.toUpperCase()}
        style={{borderColor:'forestgreen'}}/>
      </Form.Item>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '80%' }}>
      <Form.Item
        name="callback_date"
        label="Call Back Date"
        // dateFormat="DD-MM-YYYY"
        style={{marginLeft:'24%',width:'95%'}}
        
      >
         <DatePicker
          format="DD-MM-YYYY"
       style={{width:'85%',borderColor:'forestgreen',marginRight:'120px'}}
  />
      </Form.Item>
      <Form.Item  name="lead_status_list_id"
      style={{marginRight:'10px'}}
      onChange={handleNewChange}>
      <Select placeholder="Select Options" style={{ marginLeft:'100px',width: '280px' }} options = {[
   
      {
        label: 'Plain Survey',
        value: 2,
      },
      {
        label: 'Validated',
        value: 5,
      },
      {
  
        label: 'Validated Low EAC',
        value: 6,
      },
      {
        label: 'Hold',
        value: 7,
      },
      {
  
        label: 'Reject',
        value: 8,
      }

  ]}/></Form.Item></div>
      
      <Form.Item>
      <button class="button-demo" role="button" htmlType="submit"
      style={{alignContent:'center'}}>Submit</button>
      <Modal
        open={open}
        title="Please fix these following errors before submitting"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          
          <Button key="back" onClick={handleCancel}>
            OK
          </Button>
          
        ]}
      >
        <ol>
          {errors.map((error, index) => (
            <li style={{color:'red',fontSize:'20px'}}key={index}>{error}</li>
          ))}
        </ol>
      </Modal>
    {/* <Button type="primary" htmlType="submit" >Submit</Button> */}
        
      </Form.Item>
      
    </Form></></div>
  );
};
export default RegistrationFormQuality;